import { Observable } from 'rxjs/Rx'

import {
  PathConfirmation,
  PathNode
} from '../../models/'

// There is an issue with the barrel file which returns these two as undefined
// It has something to do with the load order
import { ModelRepositoryAdapter } from '../../../model-repository/model-repository-adapter'
import { ModelRepository } from '../../../model-repository/model-repository'

import { AppContext } from '../../../helpers'
import { ModelFactory } from '../../../../data/factories'

export class PathConfirmationService extends ModelRepositoryAdapter<PathConfirmation> {

  constructor(
    private _modelRepository: ModelRepository,
    private _appContext: AppContext
  ) {
    super(_modelRepository, PathConfirmation)
  }

  public isPathConfirmed(path: PathNode): Observable<boolean> {
    return this.findAllModels(['pathNode']).map((pathConfirmations: PathConfirmation[]) => {
      return pathConfirmations.some((pathConfimation: PathConfirmation) => pathConfimation.pathNode === path)
    })
  }

  public confirmPath(path: PathNode) {
    const pathConfirmation = this._modelRepository.createModel(
      PathConfirmation.name,
      {pathNode: path, userId: this._appContext.currentUser.id}
    ) as PathConfirmation
    this.save(pathConfirmation)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/path-confirmation/path-confirmation.service.ts